import ReactDOM from "react-dom/client"

import App from "@/components/App"

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
ReactDOM.createRoot(document.getElementById("root")!).render(<App />)
